import {
  LOGIN_USER_SUCCESS,
  LOGOUT,
  DEVICE_TOKEN,
} from '../actions/authActions';

const INITIAL_STATE = {
  user: null,
  deviceToken: '',
  isAuthenticated: false,
  isAdmin: false,
  loading: false,
  error: null,
};

const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_USER_SUCCESS:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
        isAdmin: action.payload?.isAdmin || false,
        loading: false,
      };
    case DEVICE_TOKEN:
      return { ...state, deviceToken: action.payload };
    case LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default authReducer;
